(() => {
  document.querySelectorAll('[data-article-media]').forEach((media) => {
    const image = media.querySelector('img');
    const status = media.querySelector('.article-detail__media-status');
    if (!image || !status) return;
    const ready = () => {
      media.dataset.state = 'ready';
      status.hidden = true;
    };
    const failed = () => {
      media.dataset.state = 'error';
      image.hidden = true;
      status.hidden = false;
      status.textContent = media.dataset.errorLabel;
    };
    if (image.complete) {
      image.naturalWidth ? ready() : failed();
      return;
    }
    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', failed, { once: true });
  });
})();